var map = {
	"./arrow-left.svg": [
		"8e99",
		"icon-arrow-left-svg"
	],
	"./arrow-long-left.svg": [
		"01d3",
		"icon-arrow-long-left-svg"
	],
	"./arrow-right.svg": [
		"1ea6",
		"icon-arrow-right-svg"
	],
	"./billing.svg": [
		"fab2",
		"icon-billing-svg"
	],
	"./bulb.svg": [
		"98c0",
		"icon-bulb-svg"
	],
	"./channel.svg": [
		"bbe7",
		"icon-channel-svg"
	],
	"./chatfood-logo.svg": [
		"e5f6",
		"icon-chatfood-logo-svg"
	],
	"./check-circle.svg": [
		"7a83",
		"icon-check-circle-svg"
	],
	"./check.svg": [
		"5182",
		"icon-check-svg"
	],
	"./checkmark.svg": [
		"7ca8",
		"icon-checkmark-svg"
	],
	"./copy.svg": [
		"bd5d",
		"icon-copy-svg"
	],
	"./cross-widget.svg": [
		"c58a",
		"icon-cross-widget-svg"
	],
	"./customers-menu.svg": [
		"7466",
		"icon-customers-menu-svg"
	],
	"./dashboard-menu.svg": [
		"7358",
		"icon-dashboard-menu-svg"
	],
	"./delivery-areas-sidebar.svg": [
		"cdbc",
		"icon-delivery-areas-sidebar-svg"
	],
	"./dine-in.svg": [
		"3ce7",
		"icon-dine-in-svg"
	],
	"./discount.svg": [
		"b134",
		"icon-discount-svg"
	],
	"./email-reminder.svg": [
		"b53c",
		"icon-email-reminder-svg"
	],
	"./eye-slash.svg": [
		"03b1",
		"icon-eye-slash-svg"
	],
	"./eye.svg": [
		"6b29",
		"icon-eye-svg"
	],
	"./help-menu.svg": [
		"001b",
		"icon-help-menu-svg"
	],
	"./house.svg": [
		"069f",
		"icon-house-svg"
	],
	"./inventory-menu.svg": [
		"e507",
		"icon-inventory-menu-svg"
	],
	"./link.svg": [
		"10de",
		"icon-link-svg"
	],
	"./live-orders-menu.svg": [
		"ba9a",
		"icon-live-orders-menu-svg"
	],
	"./loading.svg": [
		"bebc",
		"icon-loading-svg"
	],
	"./logout-menu.svg": [
		"28b2",
		"icon-logout-menu-svg"
	],
	"./map-marker.svg": [
		"5d06",
		"icon-map-marker-svg"
	],
	"./marketing-menu.svg": [
		"4cfc",
		"icon-marketing-menu-svg"
	],
	"./menu-menu.svg": [
		"c1acc",
		"icon-menu-menu-svg"
	],
	"./motorcycle.svg": [
		"168b",
		"icon-motorcycle-svg"
	],
	"./order-history-menu.svg": [
		"007a",
		"icon-order-history-menu-svg"
	],
	"./outlets-menu.svg": [
		"9bed",
		"icon-outlets-menu-svg"
	],
	"./pause-orders-menu.svg": [
		"1c8a",
		"icon-pause-orders-menu-svg"
	],
	"./plus-circle.svg": [
		"e965",
		"icon-plus-circle-svg"
	],
	"./profile-menu.svg": [
		"7222",
		"icon-profile-menu-svg"
	],
	"./report-menu.svg": [
		"286c",
		"icon-report-menu-svg"
	],
	"./rocket.svg": [
		"a7b9",
		"icon-rocket-svg"
	],
	"./sales-channels-menu.svg": [
		"c4e8",
		"icon-sales-channels-menu-svg"
	],
	"./search.svg": [
		"7a52",
		"icon-search-svg"
	],
	"./shop-circle.svg": [
		"c04d",
		"icon-shop-circle-svg"
	],
	"./shop.svg": [
		"4e90",
		"icon-shop-svg"
	],
	"./shopping-basket.svg": [
		"2f52",
		"icon-shopping-basket-svg"
	],
	"./sparkle.svg": [
		"5766",
		"icon-sparkle-svg"
	],
	"./tag.svg": [
		"ff0d",
		"icon-tag-svg"
	],
	"./thick-cross.svg": [
		"9a32",
		"icon-thick-cross-svg"
	],
	"./times-circle.svg": [
		"2513",
		"icon-times-circle-svg"
	],
	"./times.svg": [
		"ddd1",
		"icon-times-svg"
	],
	"./trash.svg": [
		"f2d7",
		"icon-trash-svg"
	],
	"./users-menu.svg": [
		"1ecd",
		"icon-users-menu-svg"
	],
	"./vip.svg": [
		"36aa",
		"icon-vip-svg"
	],
	"./zoom-in.svg": [
		"4bb6",
		"icon-zoom-in-svg"
	],
	"./zoom-out.svg": [
		"eea4",
		"icon-zoom-out-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "71a0";
module.exports = webpackAsyncContext;